import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Languages',
  basePath: '/languages',
  columns: [
    { key: 'code', label: 'Code', sortable: true },
    { key: 'title', label: 'Title (English)', sortable: true },
    { key: 'language', label: 'Local title', sortable: true },
    { key: 'status', label: 'Active', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'code', label: 'Language code', type: 'text', required: true },
    { key: 'title', label: 'Title (English)', type: 'text', required: true },
    { key: 'language', label: 'Title in local language', type: 'text' },
    { key: 'status', label: 'Active', type: 'yesno', defaultValue: 0 },
  ],
  defaultSort: { field: 'code', dir: 'asc' },
});
